import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { PermissionRedirect } from '../../account/components/sections'

import { PriorityTaskPage, PriorityTasksPage } from './pages'

const PriorityTasksRouter = () => (
  <>
    <Routes>
      <Route
        index
        element={
          <PermissionRedirect permissions={PERMISSIONS.PRIORITY_TASK.LIST}>
            <PriorityTasksPage />
          </PermissionRedirect>
        }
      />
      <Route
        path={APP_ROUTES.MENUS.children.MENU_DETAILS.path}
        element={
          <PermissionRedirect permissions={[PERMISSIONS.PRIORITY_TASK.GET]}>
            <PriorityTaskPage />
          </PermissionRedirect>
        }
      />
    </Routes>
    <Outlet />
  </>
)

export default PriorityTasksRouter
